//@config
export default {
  intelligence: {
    processingMethods: "v1/processing-methods",
    processingMethodCode: "v1/processing-methods/{0}",
    processingMethodParvandehAccessDelete:
      "v1/processing-methods/{0}/parvandeh-access/{1}/delete",
    onlineProcessingMethod: "v1/online-processing-method",
    processingMethodExtraData: "v1/processing-methods/{0}/extra-data",
    processingMethodParvandehAccess:
      "v1/processing-method/{0}/parvandeh-access",
    processingMethodDelete: "v1/processing-methods/{0}/delete",

    attachmentMyVoice: "v1/attachment-my-voice",
    adaptiveTrainingCourse: "v1/adaptive-training-course",
    adaptiveTrainingCourseByCode: "v1/adaptive-training-course/{0}",
    adaptiveTrainingCourseByCodeParvandeh:
      "v1/adaptive-training-course/{0}/parvandeh",
    adaptiveTrainingCourseParvandeh: "v1/adaptive-training-course-parvandeh",
    adaptiveTrainingCourseParvandehByCode:
      "v1/adaptive-training-course-parvandeh/{0}",
    adaptiveTrainingCourseAnswerHistory:
      "v1/adaptive-training-course-answer/{0}/history",
    myAdaptiveTrainingCourse: "v1/my-adaptive-training-course",
    myAdaptiveTrainingCourseAnswerHistory:
      "v1/my-adaptive-training-course-answer/{0}/history",
    myAdaptiveTrainingCourseByParvandehCode:
      "v1/my-adaptive-training-course/{0}",
    createAdaptiveTrainingCourseParvandehByText:
      "v1/my-adaptive-training-course-answer",
    createAdaptiveTrainingCourseParvandehByAttachment:
      "v1/my-adaptive-training-course-answer/attachment",
    myAdaptiveTrainingNextCase: "v1/my-adaptive-training-next-case",
    myAdaptiveTrainingAddInterest: "v1/my-adaptive-training-add-interest",
    processingMethodParvandehWithoutAccess:
      "v1/processing-method/{0}/parvandeh-without-access",
    flow: "v1/flow",
    flowDetails: "v1/flow/{0}/details",
    flowJobsLogFlowDetail: "v1/flow-jobs-log/{0}/flow-detail",
    flowCode: "v1/flow/{0}/edit",
    flowCodeSingle: "v1/flow/{0}",
    flowJobsLog: "v1/flow-jobs-log",
    flowJobsLogDetail: "v1/flow-jobs-log/{0}",
    flowExcelBatchExecute: "v1/flow/{0}/excel-batch-execute",
    flowJobsLogEndJob: "v1/flow-jobs-log/{0}/end-job",
    myConversationCategories: "v1/my-conversation-categories",
    conversationCategories: "v1/conversation-categories",
    conversationCategoriesCode: "v1/conversation-categories/{0}",
    myCategoryConversations: "v1/my-conversation-categories/{0}/conversations",
    myConversations: "v1/my-conversation",
    conversations: "v1/conversations",
    conversationsCode: "v1/conversations/{0}",
    conversationsChangeCategory: "v1/conversations/{0}/change-category",
    myConversationPanelMessages: "v1/my-conversation-panel/{0}/messages",
    conversationsMessage: "v1/conversations/{0}/message",
    flowExecuteAccessCode: "v1/flow/{0}/execute-access",
    flowExecuteAccess: "v1/flow-execute-access",
    flowExecuteAccessDetail: "v1/flow-execute-access/{0}",
    conversationsOther: "v1/conversations-other",
    conversationsOtherCode: "v1/conversations-other/{0}",
    conversationPanelMessages: "v1/conversation-panel/{0}/messages",
    reportIndicators: "v1/report-indicators",
    flowAssessmentData: "v1/flow/{0}/assessment-data",
    flowDeleteAssessmentDataCategory:
      "v1/flow/{0}/delete-assessment-data-category",
    flowDeleteAssessmentDataIndicator:
      "v1/flow/{0}/delete-assessment-data-category-indicator",
    flowPersonSelfDeclaredData: "v1/flow/{0}/person-self-declared-data",
    flowAttachments: "v1/attachment-flow/{0}",
    flowAttachment: "v1/attachment-flow/{0}/attachment/{1}",
  },
};
